// Fix for facet-link to work inside Shadow DOM (slot="footer")
// This extends the facet-link behavior to find section-id from facets-form when inside Shadow DOM

(function () {
  'use strict';

  function findSectionId(element) {
    // First, try to find facets-form in the same drawer
    const drawer = element.closest('facets-drawer') || element.closest('drawer');
    if (drawer) {
      const facetsForm = drawer.querySelector('facets-form');
      if (facetsForm) {
        const sectionId = facetsForm.getAttribute('section-id');
        if (sectionId) return sectionId;
      }
    }

    // Fallback: try extractSectionId if available
    if (typeof window.extractSectionId === 'function') {
      try {
        return window.extractSectionId(element);
      } catch (e) {
        // Ignore
      }
    }

    // Last resort: try to find shopify-section by traversing up
    let current = element;
    while (current) {
      if (current.classList && current.classList.contains('shopify-section')) {
        return current.id.replace('shopify-section-', '');
      }
      current = current.parentElement || (current.getRootNode && current.getRootNode().host);
      if (current === document || current === document.documentElement) break;
    }

    return null;
  }

  // Wait for DOM and custom elements
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Wait for facet-link to be defined
    const checkInterval = setInterval(() => {
      if (window.customElements.get('facet-link')) {
        clearInterval(checkInterval);
        patchFacetLink();
      }
    }, 50);

    setTimeout(() => clearInterval(checkInterval), 3000);
  }

  function patchFacetLink() {
    // Patch all existing and future facet-link elements
    const observer = new MutationObserver(() => {
      document.querySelectorAll('facet-link').forEach(patchElement);
    });

    observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });

    // Patch existing elements
    document.querySelectorAll('facet-link').forEach(patchElement);
  }

  function patchElement(element) {
    if (element._facetLinkPatched) return;
    element._facetLinkPatched = true;

    // Remove any existing click handlers added by our patch
    if (element._facetLinkHandler) {
      element.removeEventListener('click', element._facetLinkHandler);
    }

    // Add new click handler
    element._facetLinkHandler = function (event) {
      event.preventDefault();
      event.stopPropagation();

      const linkElement = this.firstElementChild;
      if (!linkElement || !linkElement.href) {
        return;
      }

      const sectionId = findSectionId(this);
      if (!sectionId) {
        console.warn('facet-link: Could not find section-id');
        return;
      }

      const url = new URL(linkElement.href);
      url.searchParams.set('section_id', sectionId);

      this.dispatchEvent(new CustomEvent('facet:update', {
        bubbles: true,
        detail: {
          url
        }
      }));
    };

    element.addEventListener('click', element._facetLinkHandler);
  }
})();
